module.exports = __webpack_public_path__ + "static/media/loader.db566ed8.svg";